<template lang="pug">
#modal-inteligencia-territorial-restricoes-socioambientais
    el-dialog.fonte-titulo-modal(
        width='645px',
        :visible.sync='abrirModalRestricoesSocioambientais_',
        @close='$emit("fecharModalRestricoesSocioambientais")'
    )
        span.title(slot='title')
            i.flow.flow-warning-sign.espacamento-title
            span Restrições socioambientais
        .bloco-dados
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='amazoniaProtege')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.amazoniaProtege') }}
                    span.color-resultado(v-if='amazoniaProtege') {{ formatoNumero(amazoniaProtege) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'AMAZONIA_PROTEGE\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'AMAZONIA_PROTEGE\')', target='_blank')  {{filtrarCamada('AMAZONIA_PROTEGE')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='areaEmbargadaIbama')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.areasEmbargadasIbama') }}
                    span.color-resultado(v-if='areaEmbargadaIbama') {{ formatoNumero(areaEmbargadaIbama) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'AREA_EMBARGADA\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'AREA_EMBARGADA\')', target='_blank')  {{filtrarCamada('AREA_EMBARGADA')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='areaEmbargadaLdi')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.areasEmbargadasLdi') }}
                    span.color-resultado(v-if='areaEmbargadaLdi') {{ formatoNumero(areaEmbargadaLdi) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'LDI\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'LDI\')', target='_blank')  {{filtrarCamada('LDI')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -

            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='areaEmbargadaGo')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.areasEmbargadasGoias') }}
                    span.color-resultado(v-if='areaEmbargadaGo') {{ formatoNumero(areaEmbargadaGo) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'AREA_EMBARGADA_GOIAS\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'AREA_EMBARGADA_GOIAS\')', target='_blank')  {{filtrarCamada('AREA_EMBARGADA_GOIAS')}}7
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='areaEmbargadaIcmbio')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.areasEmbargadasIcmbio') }}
                    span.color-resultado(v-if='areaEmbargadaIcmbio') {{ formatoNumero(areaEmbargadaIcmbio) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'AREA_EMBARGADA_ICMBIO\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'AREA_EMBARGADA_ICMBIO\')', target='_blank')  {{filtrarCamada('AREA_EMBARGADA_ICMBIO')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='areaEmbargadaSema')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.areasEmbargadasSemaMt') }}
                    span.color-resultado(v-if='areaEmbargadaSema') {{ formatoNumero(areaEmbargadaSema) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'AREA_EMBARGADA_SEMA_MT\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'AREA_EMBARGADA_SEMA_MT\')', target='_blank')  {{filtrarCamada('AREA_EMBARGADA_SEMA_MT')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='moratoriaSoja')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.moratoriaDaSoja') }}
                    span.color-resultado(v-if='moratoriaSoja') {{ formatoNumero(moratoriaSoja) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'MORATORIA_SOJA\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'MORATORIA_SOJA\')', target='_blank')  {{filtrarCamada('MORATORIA_SOJA')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='deterAmazonia')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.deterAmazonia') }}
                    span.color-resultado(v-if='deterAmazonia') {{ formatoNumero(deterAmazonia) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'DETER_AMAZONIA\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'DETER_AMAZONIA\')', target='_blank')  {{filtrarCamada('DETER_AMAZONIA')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='deterCerrado')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.deterCerrado') }}
                    span.color-resultado(v-if='deterCerrado') {{ formatoNumero(deterCerrado) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'DETER_CERRADO\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'DETER_CERRADO\')', target='_blank')  {{filtrarCamada('DETER_CERRADO')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='prodes')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.camadas.PRODES') }}
                    span.color-resultado(v-if='prodes') {{ formatoNumero(prodes) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'PRODES\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'PRODES\')', target='_blank')  {{filtrarCamada('PRODES')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='prodesCerrado')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.prodesCerrado') }}
                    span.color-resultado(v-if='prodesCerrado') {{ formatoNumero(prodesCerrado) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'PRODES_CERRADO\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'PRODES_CERRADO\')', target='_blank')  {{filtrarCamada('PRODES_CERRADO')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='unidadeConservacaoIntegral')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.unidadeConservacaoProtecaoIntegral') }}
                    span.color-resultado(v-if='unidadeConservacaoIntegral') {{ formatoNumero(unidadeConservacaoIntegral) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'UNIDADE_CONSERVACAO_PI\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'UNIDADE_CONSERVACAO_PI\')', target='_blank')  {{filtrarCamada('UNIDADE_CONSERVACAO_PI')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='unidadeConservacaoSustentavel')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.unidadeConservacaoUsoSustentavel') }}
                    span.color-resultado(v-if='unidadeConservacaoSustentavel') {{ formatoNumero(unidadeConservacaoSustentavel) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'UNIDADE_CONSERVACAO_US\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'UNIDADE_CONSERVACAO_US\')', target='_blank')  {{filtrarCamada('UNIDADE_CONSERVACAO_US')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='terrasIndigenas')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.inteligenciaTerritorial.terrasIndigenas') }}
                    span.color-resultado(v-if='terrasIndigenas') {{ formatoNumero(terrasIndigenas) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'TERRA_INDIGENA\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'TERRA_INDIGENA\')', target='_blank')  {{filtrarCamada('TERRA_INDIGENA')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
            hr
            .bloco-restricao
                .restricao-socioambientais-titulo
                    i.flow.flow-warning-sign.color-icon(style='color: red', v-if='sitiosArqueologicos')
                    i.el-icon-circle-check.color-icon(v-else)
                    span {{ $t('mensagens.camadas.SITIOS_ARQUEOLOGICOS') }}
                    span.color-resultado(v-if='sitiosArqueologicos') {{ formatoNumero(sitiosArqueologicos) }}
                    span.color-resultado(v-else) 0
                .restricao-socioambientais-fonte-dados
                    span(v-if='filtrarCamada(\'SITIOS_ARQUEOLOGICOS\')') {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}:
                        a(:href='filtrarCamada(\'SITIOS_ARQUEOLOGICOS\')', target='_blank')  {{filtrarCamada('SITIOS_ARQUEOLOGICOS')}}
                        br
                        span {{ $t('mensagens.inteligenciaTerritorial.referenteData') }} {{this.dataAtualizacao}}
                    span(v-else) {{ $t('mensagens.inteligenciaTerritorial.fonteDosDados') }}: -
</template>

<script>
import formatters from '@/utils/formatters';
import InteligenciaTerritorialService from '@/services/InteligenciaTerritorialService';

export default {
    name: 'ModalInteligenciaTerritorialRestricoesSocioambientais',
    props: {
        restricoesSocioambientais: {
            type: Object,
            default: () => {}
        },
        abrirModalRestricoesSocioambientais: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            camadas: ['AMAZONIA_PROTEGE', 'AREA_EMBARGADA', 'LDI', 'AREA_EMBARGADA_GOIAS', 'AREA_EMBARGADA_ICMBIO', 'AREA_EMBARGADA_SEMA_MT', 'MORATORIA_SOJA',
                'DETER_AMAZONIA', 'DETER_CERRADO', 'PRODES', 'PRODES_CERRADO', 'UNIDADE_CONSERVACAO_PI', 'UNIDADE_CONSERVACAO_US', 'TERRA_INDIGENA', 'SITIOS_ARQUEOLOGICOS'],
            dadosCamadas: [],
            amazoniaProtege: null,
            areaEmbargadaIbama: null,
            areaEmbargadaLdi: null,
            areaEmbargadaGo: null,
            areaEmbargadaIcmbio: null,
            areaEmbargadaSema: null,
            moratoriaSoja: null,
            deterAmazonia: null,
            deterCerrado: null,
            prodes: null,
            prodesCerrado: null,
            unidadeConservacaoIntegral: null,
            unidadeConservacaoSustentavel: null,
            terrasIndigenas: null,
            sitiosArqueologicos: null,
            dataAtualizacao: null,
            abrirModalRestricoesSocioambientais_:
            this.abrirModalRestricoesSocioambientais
        };
    },

    async mounted() {
        this.calcularRestricoes();
        await this.buscarCamadas();
    },

    methods: {
        formatoNumero(number) {
            return formatters.formatNumber(number, 0);
        },

      calcularRestricoes() {
        this.limparValores();
        this.amazoniaProtege += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoAmazoniaProtegeHa);
        this.areaEmbargadaIbama += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoEmbargosIbamaHa);
        this.areaEmbargadaLdi += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoLDIHa);
        this.areaEmbargadaGo += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoEmbargosGOHa);
        this.areaEmbargadaIcmbio += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoEmbargosIcmbioHa);
        this.areaEmbargadaSema += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoEmbargosSemasMTHa);
        this.moratoriaSoja += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoMoratoriaSojaHa);
        this.deterAmazonia += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoDeterAmazoniaHa);
        this.deterCerrado += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoDeterCerradoHa);
        this.prodes += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoProdesHa);
        this.prodesCerrado += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoProdesCerradoHa);
        this.unidadeConservacaoIntegral += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoUnidadeConservacaoProtecaoIntegralHa);
        this.unidadeConservacaoSustentavel += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoUnidadeConservacaoUsoSustentavelHa);
        this.terrasIndigenas += this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoTerraIndigenaHa);
        this.sitiosArqueologicos += this.converterStringParaFloat(this.restricoesSocioambientais.quantidadeSitiosArqueologicos);
        this.dataAtualizacao = this.restricoesSocioambientais.dataAtualizacao;
      },

        limparValores() {
            this.amazoniaProtege = null;
            this.areaEmbargadaIbama = null;
            this.areaEmbargadaLdi = null;
            this.areaEmbargadaGo = null;
            this.areaEmbargadaIcmbio = null;
            this.areaEmbargadaSema = null;
            this.moratoriaSoja = null;
            this.deterAmazonia = null;
            this.deterCerrado = null;
            this.prodes = null;
            this.prodesCerrado = null;
            this.unidadeConservacaoIntegral = null;
            this.unidadeConservacaoSustentavel = null;
            this.terrasIndigenas = null;
            this.sitiosArqueologicos = null;
            this.dataAtualizacao = null;
        },
        closeModalInteligenciaTerritorialRestricoesSocioambientais() {
            this.changeShowInteligenciaTerritorialRestricoesSocioambientaisModal();
        },
        converterStringParaFloat(valor) {
            if (valor === null || valor === '') {
                return 0;
            } else {
                return parseFloat(valor);
            }
        },
        async buscarCamadas() {
            await InteligenciaTerritorialService.buscarCamadas(
                this.camadas
            ).then(({data}) => {
               this.dadosCamadas = data;
            });
        },
        filtrarCamada(codigo) {
            let camada = this.dadosCamadas.filter(camada => camada.codigo === codigo);
            if (camada.length > 0) {
                return camada[0].fontes[0].url;
            } else {
                return null;
            }
        }
    }
};
</script>

<style lang="scss">
#modal-inteligencia-territorial-restricoes-socioambientais {
    .bloco-dados {
        height: 500px;
        background: var(--white);
        font-size: 16px;
        color: #3b3b3b;
        margin: 1%;
        margin-top: 0px;
        display: flex;
        position: relative;
        flex-direction: column;
        overflow-y: auto;
    }

    .bloco-dados::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    .bloco-dados::-webkit-scrollbar-track {
        border-radius: 10px;
        background: #d9d9d9;
    }

    /* Handle */
    .bloco-dados::-webkit-scrollbar-thumb {
        background-color: var(--primary);
        border-radius: 10px;
        border: 0px;
    }

    /* Handle on hover */
    .bloco-dados::-webkit-scrollbar-thumb:hover {
        background-color: var(--secondary);
        min-height: 40px;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: var(--black);
        font-size: 22px;
    }

    .el-dialog__headerbtn .el-dialog__close:focus-visible,
    :hover,
    :focus {
        outline: -webkit-focus-ring-color auto 0px;
        border: transparent;
    }

    .title {
        font-size: 18px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
        color: var(--primary);
    }

    .espacamento-title {
        font-weight: bold;
        font-size: 20px;
        margin-right: 3%;
    }

    .el-dialog__header {
        background-color: var(--default-background-color);
    }

    .bloco-restricao {
        margin-left: 5%;
        margin-right: 5%;
    }

    .restricao-socioambientais-titulo {
        display: flex;
        padding-top: 5%;
        margin-bottom: 2%;
        font-weight: 500;
    }

    .restricao-socioambientais-fonte-dados {
        display: flex;
        padding-top: 1px;
        margin-bottom: 2%;
        font-weight: 400;
    }

    hr {
        box-sizing: border-box;
        margin-left: 1px;
        width: 94%;
        margin-top: 0px;
        margin-bottom: 0px;
        border-color: var(--black);
    }

    .color-icon {
        color: green;
        padding-top: 1px;
        margin-right: 1rem;
        font-size: 20px;
    }

    .color-resultado {
        color: green;
        margin-left: 1rem;
    }
}
</style>
